export enum HANDLER {
  crif = 'crif',
  namirial = 'namirial',
  experian = 'experian',
  mitek = 'mitek'
}
